import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';

import {environment} from 'environment';
import {IEmailConfirmationRepository} from './email-confirmation.repository.interface';

@Injectable()
export class EmailConfirmationRepository implements IEmailConfirmationRepository {

  constructor(private http: HttpClient) { }

  public confirm(email: string, token: string): Observable<string> {
    const headers: HttpHeaders = new HttpHeaders();
    headers.append('Content-Type', 'application/json');

    return this.http.post<string>(`${environment.email_confirmation}/confirm`, {'email': email, 'token': token}, {headers: headers, withCredentials: true})
      .pipe(
//        map((response: Response) => response.json()),
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return an observable with a user-facing error message.
    return throwError(() => new Error('Something bad happened; please try again later.'));
  }
}
